import { Link } from "@tanstack/react-router";
import { PATHS } from "@/config/paths";
import { APP_NAME } from "@/config/constants";
import { useTranslation } from "@/hooks/useTranslation";

type LegalLinksProps = {
  closeDialog?: () => void;
};

export function LegalLinks({ closeDialog }: LegalLinksProps) {
  const { t } = useTranslation();

  return (
    <p className="text-balance text-center text-sm leading-loose text-muted-foreground">
      {t("legal.agreement_text", { appName: APP_NAME })}{" "}
      <Link
        to={PATHS.TERMS_OF_SERVICE}
        onClick={closeDialog}
        className="underline hover:text-primary"
      >
        {t("legal.terms_of_service")}
      </Link>
      . {t("legal.read_our")}{" "}
      <Link
        to={PATHS.PRIVACY_POLICY}
        onClick={closeDialog}
        className="underline hover:text-primary"
      >
        {t("legal.privacy_policy")}
      </Link>
      .
    </p>
  );
}
